import { Contract } from 'ethers';
import contractABI from 'abis/agentContract.json';

export const getDepositContract = (
	address: string,
	provider: any,
): Contract => {
	return new Contract(address, contractABI, provider);
};
